export interface IState {
  recentLeadData: any;
  recentEstimateData: any;
  recentTaskData: any;
  dashboarCounts: any;
  recentIssueData: any;
  recentInvoiceData: any;
  customerDashboarCounts: any;
}

type Action = any;

export const dashboardReducer = (
  state: IState = {
    recentLeadData: [],
    recentEstimateData: [],
    recentTaskData: [],
    recentIssueData: [],
    recentInvoiceData: [],
    dashboarCounts: {},
    customerDashboarCounts: {},
  },
  action: any
): any => {
  switch (action.type) {
    case "RECENT_LEAD_DATA":
      return {
        ...state,
        recentLeadData: action.payload,
      };
    case "RECENT_ESTIMATE_DATA":
      return {
        ...state,
        recentEstimateData: action.payload,
      };
    case "DASHBOARD_SUCCESS":
      return {
        ...state,
        dashboarCounts: action.payload,
      };
    case "CUSTOMER_DASHBOARD_SUCCESS":
      return {
        ...state,
        customerDashboarCounts: action.payload,
      };

    case "GET_RECENT_TASK":
      return {
        ...state,
        recentTaskData: action.payload,
      };
    case "GET_RECENT_ISSUE":
      return {
        ...state,
        recentIssueData: action.payload,
      };
    case "GET_RECENT_INVOICES_DATA":
      return {
        ...state,
        recentInvoiceData: action.payload,
      };

    default:
      return state;
  }
};
